import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteFaxModalProps = {
  show: boolean
  count: number
  permanent?: boolean
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteFaxModal: React.FC<
  MessageCenterDeleteFaxModalProps
> = ({ show, count, permanent = false, onCancel, onDelete }) => (
  <Modal
    open={show}
    onClose={onCancel}
    size="xs"
    title="Delete fax"
    description={
      permanent
        ? `Are you sure you want to permanently delete ${count} fax messages? This action can't be undone.`
        : `Are you sure you want to delete ${count} fax messages? These fax messages will be moved to the trash folder.`
    }
    primaryLabel={permanent ? 'Permanently delete' : 'Delete'}
    secondaryLabel="Cancel"
    primaryDestructive
    onPrimaryClick={onDelete}
    onSecondaryClick={onCancel}
  />
)

export default MessageCenterDeleteFaxModal
